export default __webpack_public_path__ + "static/media/parapng.39b98811.png";